// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1JiK2","tab":"Tabs_tab__8O_vS","tabActive":"Tabs_tabActive__1Zrru"};